<!--
 * @message: 全局警告、错误弹窗组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-09-11 15:29:22
 * @FilePath: \mrc-ess-fronted\src\components\confirm\src\confirm.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-17 16:52:34
-->
<template>
  <v-overlay v-model="show" z-index="9999999999">
    <v-card
      :elevation="5"
      rounded
      light
      min-width="300"
      max-width="600"
      class="card_style animated zoomIn"
    >
      <v-toolbar
        style="background: #fff; padding-right: 0px"
        flat
        dense
        height="40"
      >
        <v-toolbar-title class="text-h4">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text style="padding: 32px 16px">
        <slot name="content">
          <v-sheet class="text-body-1" v-html="text">{{ text }}</v-sheet>
        </slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          class="btn_style"
          rounded
          v-for="(item, index) in button"
          v-show="item.show"
          :key="`button--${index}`"
          @click="item.ontap"
          >{{ item.text }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-overlay>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      title: "",
      text: "",
      button: [],
    };
  },
  methods: {},
};
</script>

<style scoped>
/* confirm组件不支持外部class样式 */
.btn_style {
  height: 32px;
  color: var(--main-color);
  /* padding-left: 28px; */
  text-transform: capitalize !important;
  /* padding-right: 28px; */
}
.card_style {
  animation-duration: 0.3s !important;
  border-radius: 8px;
  padding: 32px 16px 24px 16px;
}
.text-h4 {
  font-family: var(--main-font-family) !important ;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 24px !important;
  line-height: 32px !important;
}
.text-body-1 {
  font-family: var(--main-font-family) !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 22px !important;
}
</style>
